import { defineStore } from "pinia";

import axios from "../../axios-auth";
import { useUrlsStore } from "@/stores/modules/urls";
import { useBundleStore } from "@/stores/modules/bundle";
import { useWebproductStore } from "@/stores/modules/webproduct";
import {
  callbackService,
  isRegisteredCallback
} from "../../helpers/callbackService";

export const usePersonalizeStore = defineStore("personalize", {
  state: () => ({
    personalizeLoading: false,
    customizedProductId: "",
    pq_type: ""
  }),

  getters: {
    getPersonalizationStatus(state) {
      return this.getCustomizedProductId.length > 0;
    },
    getCustomizedProductId(state) {
      const bundleStore = useBundleStore();
      if (
        bundleStore.getBundleIsActive &&
        typeof state.customizedProductId == "object"
      ) {
        return JSON.stringify(state.customizedProductId);
      }
      return state.customizedProductId;
    },
    getCustomizedProductPqType(state) {
      return state.pq_type;
    },
    getPPWithCustomizedProductId(state) {
      if (typeof state.customizedProductId == "string") {
        return [];
      }
      return Object.keys(state.customizedProductId);
    },
    getPersonalizeLoading(state) {
      return state.personalizeLoading;
    }
  },

  actions: {
    setCustomizedProductId(payload) {
      const bundleStore = useBundleStore();
      let pq_type = null;
      if (bundleStore.getBundleIsActive) {
        const emptyObj =
          typeof this.customizedProductId == "string"
            ? {}
            : this.customizedProductId;
        this.customizedProductId = {
          ...emptyObj,
          [payload.product_part]: {
            id: payload.customizedProductId,
            type: payload.pq_type,
            rendered: false
          }
        };
      } else {
        this.customizedProductId = payload.customizedProductId;
        this.setCustomizedProductPqType(pq_type);
      }
    },
    setBundleEmptyCustomizedProductId(payload) {
      this.customizedProductId = {};
    },
    setCustomizedProductPqType(payload) {
      this.pq_type = payload;
    },
    setPersonalizeLoading(payload) {
      this.personalizeLoading = payload;
    },
    getPersonalizeUrl(payload) {
      const urlsStore = useUrlsStore();
      const webproductStore = useWebproductStore();
      var params = payload.params;

      if (
        isRegisteredCallback(
          callbackService.callbacks.beforePersonalizeCallback
        )
      ) {
        params = callbackService.sendCallback(
          callbackService.callbacks.beforePersonalizeCallback,
          payload.params
        );
        if (!params) {
          return;
        }
      }

      this.setPersonalizeLoading(true);

      axios.instance
        .get(urlsStore.getUrl(axios.getPersonalizeUrl), {
          params
        })
        .then(response => {
          const { data } = response;
          if (data) {
            const { success } = data;
            if (success) {
              const { url } = data;
              const { personalizationCB } = payload;
              if (typeof personalizationCB === "function") {
                personalizationCB(url);
                if (payload.params.isPersonalizationNewPage) {
                  // in this case do not close the loading
                  return;
                }
              }
            } else {
              const { message } = data;
              webproductStore.getSweetAlert({
                text: message,
                icon: "error"
              });
            }
          }
          this.setPersonalizeLoading(false);
        })
        .catch(error => {
          webproductStore.getSweetAlert({
            text: "Error " + error,
            icon: "error"
          });
          this.setPersonalizeLoading(false);
        });
    }
  }
});
